import React from "react";
import {
  Box,
  Progress,
  Text,
  Badge,
  Tooltip,
  Flex,
} from "@chakra-ui/react";
import { CheckCircleIcon, WarningIcon } from "@chakra-ui/icons";

export default function SlotUnlockVisualizer({
  slotCount = 0,
  unlockThreshold = 15,
  flyerId,
}) {
  const isUnlocked = slotCount >= unlockThreshold;
  const progressPercent = Math.min(
    (slotCount / unlockThreshold) * 100,
    100
  );

  return (
    <Box
      p={4}
      borderWidth="1px"
      borderRadius="md"
      bg="white"
      boxShadow="md"
    >
      <Text fontSize="lg" fontWeight="bold" mb={2}>
        📦 Slot Unlock Progress
      </Text>

      <Progress
        value={progressPercent}
        colorScheme={isUnlocked ? "green" : "orange"}
        size="md"
        borderRadius="md"
      />

      <Flex mt={3} align="center" justify="space-between">
        <Tooltip
          label={`Current: ${slotCount} / Required: ${unlockThreshold}`}
          hasArrow
        >
          <Badge
            colorScheme={isUnlocked ? "green" : "orange"}
            fontSize="md"
          >
            {slotCount} / {unlockThreshold}
          </Badge>
        </Tooltip>

        <Flex
          align="center"
          color={isUnlocked ? "green.500" : "orange.500"}
        >
          {isUnlocked ? (
            <CheckCircleIcon mr={1} />
          ) : (
            <WarningIcon mr={1} />
          )}
          <Text fontSize="sm">
            {isUnlocked ? "Ready to Dispatch" : "Waiting for More Slots"}
          </Text>
        </Flex>
      </Flex>

      {flyerId && (
        <Text mt={2} fontSize="xs" color="gray.500">
          Flyer ID: {flyerId}
        </Text>
      )}
    </Box>
  );
}
